<!-- 
Levy estimator page.
Displays the levy estimator for a particular provider, as identified by their estimator key (a guid).
Because these are publicly visible we don't display the provider name or identifying information anywhere.
If viewed by a signed-in departmental staff member the screen will also show a button to return to the 
levy collection provider screen.
-->
<template>
  <div>
    <div v-if="isSignedIn && loaded">
      <v-btn 
        :to="`/levy-collections/${levyCollection.id}/providers/${levyCollectionProvider.providerId}/calculation`" 
        flat color="primary" class="ml-0"
      >
        <v-icon class="mr-2">arrow_back</v-icon>
        Go to levy collection provider
      </v-btn>
    </div>
    <v-card>
      <div v-if="loaded">
        <div class="text-xs-center mb-3 pt-4">
          <img src="@/assets/aus-govt-logo-centered.png" alt="Australian Government" height="150px">
        </div>
        <h1 class="display-2 text-xs-center">
          {{ title }}
        </h1>
      </div>
      <v-card-text>
        <our-loading-indicator v-if="loading" />
        <levy-calculation-panel
          v-if="loaded"
          :levy-collection="levyCollection"
          :levy-collection-provider="levyCollectionProvider"
          :estimator-key="key"
          mode="levy-estimator"
        />
        <p v-if="invalidkey" class="text-xs-center my-5">
          The URL for your levy estimate is not valid. 
        </p>
      </v-card-text>
    </v-card>
    <disclaimer-copyright-and-privacy-links />
  </div>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import LevyCalculationPanel from "@/components/levy-collection-providers/calculation/LevyCalculationPanel.vue";
import DisclaimerCopyrightAndPrivacyLinks from "@/components/system/DisclaimerCopyrightAndPrivacyLinks.vue";
import * as action from "@/store/levy-estimator/action-types";
import * as mutation from "@/store/levy-estimator/mutation-types";

export default {
  name: "Estimator",
  components: { LevyCalculationPanel, DisclaimerCopyrightAndPrivacyLinks },
  mixins: [lookupMixins],
  computed: {
    key() {
      return this.$route.params.key;
    },
    state() {
      return this.$store.state.levyEstimator.playground.active
        ? this.$store.state.levyEstimator.playground
        : this.$store.state.levyEstimator.estimator;
    },
    loading() {
      return this.$store.state.levyEstimator.estimator.loading;
    },
    levyCollection() {
      return this.state.loaded ? this.state.data.levyCollection : null;
    },
    levyCollectionProvider() {
      return this.state.loaded ? this.state.data.levyCollectionProvider : null;
    },
    loaded() {
      return this.state.loaded && !this.state.data.invalidkey;
    },
    invalidkey() {
      return this.state.loaded && this.state.data.invalidkey;
    },
    isSignedIn() {
      return this.$store.getters.isSignedIn;
    },
    title() {
      return this.loaded
        ? `${this.levyCollection.year} ${
            this.lookups.levyCollectionTypeDescriptions[this.levyCollection.type]
          } tuition protection levy estimate`
        : "";
    }
  },
  watch: {
    key() {
      this.load();
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store.commit(mutation.PLAYGROUND_EDIT_QUIT);
      this.$store.dispatch(action.VIEW_REFRESH, this.key);
    }
  }
};
</script>
